<template>
  <f7-page name="ccm-code-apply" class="page-bg-render">
    <f7-navbar>
			<f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <div class="title">
        문제풀이
      </div>
			<f7-nav-right>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="right"></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <f7-block-title>문제풀이 코드 입력</f7-block-title>
    <div class="list no-hairlines-between">
      <ul>
        <li class="item-content item-input item-input-outline">
          <div class="item-inner">
            <div class="item-title item-floating-label">문제풀이 코드</div>
            <div class="item-input-wrap">
              <input type="text" ref="code" :value="code.toUpperCase()" @input="code = $event.target.value.toUpperCase()" v-on:keyup.enter="onEnterKey">
              <span class="input-clear-button"></span>
            </div>
          </div>
        </li>
        <li>
          <div class="item-content">
            <div class="item-inner">
              <button class="button button-fill color-green" v-on:click="applyStart">문제풀이 시작</button>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <f7-block-title>문제풀이 내역</f7-block-title>
		<div class="list">
			<ul>
				<template v-for="(item, i) in applyList">
					<li v-if="isNewGroup(item, i)" :key="'gi' + i" class="list-group-title" style="height:30px; font-size:14px;">{{dateDisplay(item)}}</li>
					<li :key="'ii' + i">
						<a href="#" class="item-link item-content" v-on:click="showApplyResult(item.CODE, item.STUDY_KEY, item.RESULT_KEY)">
							<div class="item-media">
								<i class="f7-icons text-color-purple">doc_text</i>
								<span>{{item.CODE}}</span>
							</div>
							<div class="item-inner">
								<div class="item-title">{{item.STUDY_NAME}}</div>
							</div>
						</a>
					</li>
				</template>
			</ul>
		</div>

    <div class="sheet-modal sheet-modal-top mb-page-exam-no-modal" style="height:auto;">
			<div class="toolbar toolbar-bottom">
				<div class="toolbar-inner">
					<div class="left"></div>
					<div class="right"><a class="link sheet-close text-color-primary" href="#">닫기</a></div>
				</div>
			</div>
			<div class="sheet-modal-inner">
				<div class="list">
          <ul>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  매칭북 코드 : {{code}}
                </div>
              </div>
            </li>
            <li class="row text-align-center">
              <div class="col">
                <small class="display-block">시작 페이지</small>
                <div ref="startPageNo" @stepper:change="onChangeStepper" class="stepper stepper-small stepper-fill stepper-init" data-wraps="false" data-autorepeat="true" data-autorepeat-dynamic="true">
                  <div class="stepper-button-minus"></div>
                  <div class="stepper-input-wrap">
                    <input type="text" value="1" min="1" max="500" step="1">
                  </div>
                  <div class="stepper-button-plus"></div>
                </div>
              </div>
              <div class="col">
                <small class="display-block">시작 번호</small>
                <div ref="startExamNo" @stepper:change="onChangeStepper" class="stepper stepper-small stepper-fill stepper-init" data-wraps="false" data-autorepeat="true" data-autorepeat-dynamic="true">
                  <div class="stepper-button-minus"></div>
                  <div class="stepper-input-wrap">
                    <input type="text" value="1" min="1" max="2000" step="1">
                  </div>
                  <div class="stepper-button-plus"></div>
                </div>
              </div>
            </li>
            <li class="row text-align-center padding-bottom">
              <div class="col">
                <small class="display-block">끝 페이지</small>
                <div ref="endPageNo" @stepper:change="onChangeStepper" class="stepper stepper-small stepper-fill stepper-init" data-wraps="false" data-autorepeat="true" data-autorepeat-dynamic="true">
                  <div class="stepper-button-minus"></div>
                  <div class="stepper-input-wrap">
                    <input type="text" value="1" min="1" max="500" step="1">
                  </div>
                  <div class="stepper-button-plus"></div>
                </div>
              </div>
              <div class="col">
                <small class="display-block">끝 번호</small>
                <div ref="endExamNo" @stepper:change="onChangeStepper" class="stepper stepper-small stepper-fill stepper-init" data-wraps="false" data-autorepeat="true" data-autorepeat-dynamic="true">
                  <div class="stepper-button-minus"></div>
                  <div class="stepper-input-wrap">
                    <input type="text" value="1" min="1" max="100" step="1">
                  </div>
                  <div class="stepper-button-plus"></div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="text-align-center">
          <button class="button button-fill" v-on:click="startMatchBookApplyButtonClick" style="width: unset; display: inline-block;">매칭북 문제풀이 시작</button>
        </div>
				<div class="block" style="height:var(--f7-toolbar-height);">&nbsp;<!-- 툴바만큼 height 확보 --></div>
			</div>
		</div>
    
  </f7-page>
</template>

<script>
import { f7 } from 'framework7-vue';
import MODULE from '../../../js/common/module';
import Vue from 'vue';
import PAGES from '../../../js/pages';
import AUTH from '../../../js/common/auth.js'
import CONST from '../../../js/common/constant';
import API from '../../../js/common/api';

export default {
  data() {
    return {
      code: "",
      matchBookData: {
        sheet: undefined,
        startPageNo: 1,
        startExamNo: 1,
        endPageNo: 1,
        endExamNo: 1
      },
      applyList: []
    }
  },
  mounted() {
    this.loadCodeSelfApplyList();
    $(document).on('page:reinit', '.page[data-name="ccm-code-apply"]', this.onPageShow);
  },
  methods: {
    onPageShow(e) {
      this.loadCodeSelfApplyList();
    },
    isNewGroup(item, i) {
			if (i > 0) {
				var prevItem = this.applyList[i-1];
				var prevItemWriteDate = moment(prevItem.WRITE_DATETIME);

				var currItem = item;
				var currItemWriteDate = moment(currItem.WRITE_DATETIME);

				if (currItemWriteDate.isSame(prevItemWriteDate, 'd')) {
					return false;
				}
			}

			return true;
    },
    dateDisplay(item) {
			var dateName = MODULE.Util.datediff(item.WRITE_DATETIME);
			var dateFormat = moment(item.WRITE_DATETIME).format("YYYY-MM-DD");

			return dateName + " (" + dateFormat + ")";
		},
    onEnterKey() {
      this.applyStart();
    },
    onChangeStepper() {
      const stepperStartPageNo = this.$refs.startPageNo.f7Stepper;
      const stepperStartExamNo = this.$refs.startExamNo.f7Stepper;
      const stepperEndPageNo = this.$refs.endPageNo.f7Stepper;
      const stepperEndExamNo = this.$refs.endExamNo.f7Stepper;

      if (stepperStartPageNo.value == stepperEndPageNo.value) {
        if (stepperEndExamNo.value < stepperStartExamNo.value) {
          stepperEndExamNo.setValue(stepperStartExamNo.value);
        }
      } else if (stepperStartPageNo.value > stepperEndPageNo.value) {
        stepperEndPageNo.setValue(stepperStartPageNo.value);
        stepperEndExamNo.setValue(stepperStartExamNo.value);
      }

      this.matchBookData.startPageNo = stepperStartPageNo.value;
      this.matchBookData.startExamNo = stepperStartExamNo.value;
      this.matchBookData.endPageNo = stepperEndPageNo.value;
      this.matchBookData.endExamNo = stepperEndExamNo.value;
    },
    showMBPageExamNoSheetModal() {
			// sheet 는 열때마다 생성, 닫을때 제거해야 정상 동작 한다.

			if (this.matchBookData.sheet == undefined) {
				this.matchBookData.sheet = f7.sheet.create({
					el: '.mb-page-exam-no-modal',
					swipeToClose: false,
					swipeToStep: false,
					backdrop: true
				});
			}
			
			this.matchBookData.sheet.open();
    },
    startMatchBookApplyButtonClick() {
      var startPageNo = this.matchBookData.startPageNo;
      var startExamNo = this.matchBookData.startExamNo;
      var endPageNo = this.matchBookData.endPageNo;
      var endExamNo = this.matchBookData.endExamNo;

      if (
        (startPageNo == endPageNo && startExamNo <= endExamNo) ||
        (startPageNo < endPageNo)
      ) {

        this.matchBookData.sheet.close();

        var url = PAGES.SUB_CCM_MATCHBOOK_APPLY;
        var param = {
          code: this.code,
          startPageNo: startPageNo,
          startExamNo: startExamNo,
          endPageNo: endPageNo,
          endExamNo: endExamNo,
          studyKey: undefined
        }
        PAGES.popPage(url, param);
      }
    },  
    showApplyResult(code, studyKey, studyResultKey) {
      var prefix = MODULE.Util.codePrefix(code);

      if (prefix == CONST.linkExamCodePrefix) {
        return;
      } else if (prefix == CONST.examSetCodePrefix) {
        var examSetKey = MODULE.Util.codeToKey(CONST.examSetCodePrefix, code);
        if (examSetKey <= 0) {
          MODULE.DialogBox.message("에러", "잘못된 코드입니다.<br/>코드를 확인하세요.");
          return;
        }

        var url = PAGES.SUB_CCM_EXAMSET_APPLY;
        var param = {
          studyResultKey: studyResultKey,
          studyType: "exam-sdy",
          studyKey: studyKey
        }
        PAGES.popPage(url, param);
      } else if (prefix == CONST.lectureCodePrefix) {
        return;
      } else if (prefix == CONST.matchPaperCodePrefix) {
        var url = PAGES.SUB_CCM_MATCHPAPER_APPLY;
        var param = {
          code: code,
          studyKey: studyKey
        }
        PAGES.popPage(url, param);
      } else if (prefix == CONST.matchBookCodePrefix) {
        var url = PAGES.SUB_CCM_MATCHBOOK_APPLY;
        var param = {
          code: this.code,
          startPageNo: undefined,
          startExamNo: undefined,
          endPageNo: undefined,
          endExamNo: undefined,
          studyKey: studyKey
        }
        PAGES.popPage(url, param);
      } else if (prefix == CONST.smartBookCodePrefix) {
        
      } else if (prefix == CONST.pqatCodePrefix) {
        // 나중에 개발 예정
      } else {
        return;
      }
    },
    applyStart() {
      const code = this.code;

      if (MODULE.Util.isEmpty(code)) {
        MODULE.DialogBox.message("코드를 입력하세요.");
        return;
      }

      var prefix = MODULE.Util.codePrefix(code);
      if (prefix == CONST.linkExamCodePrefix) {
        MODULE.DialogBox.message("에러", "문제풀이 코드가 아닙니다.<br/>코드를 확인하세요.");
        return;
      } else if (prefix == CONST.examSetCodePrefix) {
        var examSetKey = MODULE.Util.codeToKey(CONST.examSetCodePrefix, code);
        if (examSetKey <= 0) {
          MODULE.DialogBox.message("에러", "잘못된 코드입니다.<br/>코드를 확인하세요.");
          return;
        }

        var url = PAGES.SUB_CCM_EXAMSET_APPLY;
        var param = {
          studyType: "exam-sdy",
          examSetKey: examSetKey,
          studyKey: undefined
        }
        PAGES.popPage(url, param);
      } else if (prefix == CONST.lectureCodePrefix) {
        MODULE.DialogBox.message("에러", "문제풀이 코드가 아닙니다.<br/>코드를 확인하세요.");
        return;
      } else if (prefix == CONST.matchPaperCodePrefix) {
        var matchPaperKey = MODULE.Util.codeToKey(CONST.matchPaperCodePrefix, code);
        if (matchPaperKey <= 0) {
          MODULE.DialogBox.message("에러", "잘못된 코드입니다.<br/>코드를 확인하세요.");
          return;
        }

        var url = PAGES.SUB_CCM_MATCHPAPER_APPLY;
        var param = {
          code: code,
          studyKey: undefined
        }
        PAGES.popPage(url, param);
      } else if (prefix == CONST.matchBookCodePrefix) {
        var matchBookKey = MODULE.Util.codeToKey(CONST.matchBookCodePrefix, code);
        if (matchBookKey <= 0) {
          MODULE.DialogBox.message("에러", "잘못된 코드입니다.<br/>코드를 확인하세요.");
          return;
        }

        this.showMBPageExamNoSheetModal(code);
      } else if (prefix == CONST.smartBookCodePrefix) {
        
      } else if (prefix == CONST.pqatCodePrefix) {
        // 나중에 개발 예정
      } else {
        MODULE.DialogBox.message("에러", "잘못된 코드입니다.<br/>코드를 확인하세요.");
        return;
      }
    },
    loadCodeSelfApplyList() {
      var _this = this;

      var startDate = moment().add(-2, "days").format("YYYY-MM-DD");
      var endDate = moment().format("YYYY-MM-DD");


			let param = {
        pStartDate : startDate,
        pEndDate : endDate
			};

			API.ajaxRequest({
				url: API.getCodeSelfApplyListUrl(),
				data: param
			}).then(function (data) {

				_this.applyList = data.applyList;

			}).catch(function (code) {
        MODULE.UITool.catchBlock(code, PAGES, AUTH);
			});
    }
  }
}

</script>